export enum UrlEnum {
  FAREFINDER_REDIRECT_URL = 'FAREFINDER_REDIRECT_URL',
  AUTH_URL = 'AUTH_URL',
  AUTH_API_URL = 'AUTH_API_URL',
  LOGOUT_URL = 'LOGOUT_URL',

  // ORDER API
  ORDER_API_URL = 'ORDER_API_URL',
  POST_SEARCH_ORDER = 'POST_SEARCH_ORDER',

  // WEB API
  GET_ORDER_DETAILS = 'GET_ORDER_DETAILS',
  GET_ORDER_SUMMARY = 'GET_ORDER_SUMMARY',
  GET_ORDER_CONFIRMATION = 'GET_ORDER_CONFIRMATION',
  GET_BOOKED_FLIGHT = 'GET_BOOKED_FLIGHT',
  GET_AFFILIATE_OPTIONS = 'GET_AFFILIATE_OPTIONS',
  GET_BOOKED_FLIGHT_TICKET_CONDITIONS = 'GET_BOOKED_FLIGHT_TICKET_CONDITIONS',

  // FLIGHT CHANGE API
  POST_FLIGHT = 'POST_FLIGHT',
  POST_FLIGHT_CANCEL_INFO = 'POST_FLIGHT_CANCEL_INFO',
  AIRPORTS_URL = 'AIRPORTS_URL',
  POST_FLIGHT_SELECT = 'POST_FLIGHT_SELECT',
  POST_CHANGED_FLIGHT = 'POST_CHANGED_FLIGHT',

  // FLIGHT EXTRAS CONFIRM API
  POST_CONFIRM_EXTRAS = 'CONFIRM_EXTRAS',

  // MYFF_BFF
  GET_ORDERS = 'GET_ORDERS',
  GET_OPTION_ORDERS = 'GET_OPTION_ORDERS',
  GET_EXTRAS_INFO = 'GET_EXTRAS_INFO',
  PUT_EXTRAS_INFO = 'PUT_EXTRAS_INFO',
  UPDATE_LOUNGE = 'UPDATE_LOUNGE',
  UPDATE_AIRPORT_ASSISTANCE = 'UPDATE_AIRPORT_ASSISTANCE',
  GET_FINAL_BOOKED_ORDER = 'GET_FINAL_BOOKED_ORDER',
  GET_FINAL_ORDER_ACTION_INFO = 'GET_FINAL_ORDER_ACTION_INFO',
  GET_OPTION_ORDER_LIST = 'GET_OPTION_ORDER_LIST',
  GET_OPTION_ORDER_DETAILS = 'GET_OPTION_ORDER_DETAILS',
  DELETE_OPTION_ORDER = 'DELETE_OPTION_ORDER',
  CANCEL_FLIGHT = 'CANCEL_FLIGHT',
  SPLIT_PNR = 'SPLIT_PNR',
  FLIGHT_CONFIRMATION = 'FLIGHT_CONFIRMATION',
  GET_FLIGHTS_AND_FILTERS = 'GET_FLIGHTS_AND_FILTERS',
  BOOKED_FLIGHT_TICKET_CONDITIONS = 'BOOKED_FLIGHT_TICKET_CONDITIONS',
  VALIDATE_OPTION_ORDER = 'VALIDATE_OPTION_ORDER',
  FINALIZE_OPTION_ORDER = 'FINALIZE_OPTION_ORDER',
  PAX_CHANGE_DATA = 'PAX_CHANGE_DATA',
  UPDATE_PAX_DATA = 'UPDATE_PAX_DATA',
  CONFIRM_PAX_DATA = 'CONFIRM_PAX_DATA',
  GET_COMMON_ORDER_DETAILS = 'GET_COMMON_ORDER_DETAILS',
  GET_COMMON_ORDER_DETAILS_WITH_ACTION_INFO = 'GET_COMMON_ORDER_DETAILS_WITH_ACTION_INFO',
  SEND_INVOICE = 'SEND_INVOICE',
  SEND_ETICKET = 'SEND_ETICKET',
  DELETE_COMMON_ORDER = 'DELETE_COMMON_ORDER',
  GET_TICKET_CONDITIONS = 'GET_TICKET_CONDITIONS',

  // Analytics
  SEND_FINAL_ORDER_ANALYTICS = 'SEND_FINAL_ORDER_ANALYTICS',
  SEND_LOGIN_ANALYTICS = 'SEND_LOGIN_ANALYTICS',
}

export type UrlEnumType = keyof typeof UrlEnum;
